// @ts-strict-ignore
import { IOperation } from '@shared/undo/operation/i-operation';
import { BaseConnectionOperation } from './base-connection-operation';

export class AddConnectionOperation extends BaseConnectionOperation implements IOperation {

  public getQualifiedClassName(): string {
    return 'ConnectionAddOperation';
  }

  public async performRedo(): Promise<void> {
      this.attachConnection();
  }

  public async performUndo(): Promise<void> {
    this.detachConnection();
  }

  public getOperationDescription(): string {
    return 'addConnectionOperation.description';
  }
}
